import React from 'react';

const HelpIcon = ({ size = '24px', className = '' }) => {
  return (
    <svg 
      className={className}
      fill="none" 
      height={size} 
      viewBox="0 0 24 24" 
      width={size} 
      xmlns="http://www.w3.org/2000/svg"
    >
      <path 
        className="Ui-fill" 
        clipRule="evenodd" 
        d="m20 12c0 4.4183-3.5817 8-8 8-4.41828 0-8-3.5817-8-8 0-4.41828 3.58172-8 8-8 4.4183 0 8 3.58172 8 8zm-8.0779-4.18182c.7305.00952 1.3636.1237 1.9091.49478 1.1298.77071 1.198 2.24554.1461 3.11134-.1617.1305-.3335.2461-.5045.3611v.0001c-.066.0443-.1318.0886-.1968.1336-.4383.295-.7987.609-.8085 1.1989-.0097.3901-.3701.6185-.7987.5804-.4091-.038-.6331-.2379-.6623-.666-.0292-.6185.1948-1.1133.6818-1.4844.156-.1242.3189-.235.4826-.3463.1122-.0763.2247-.1528.3356-.2341.5941-.4377.7597-1.05613.4188-1.50333-.3604-.47575-1.198-.5709-1.7532-.20933-.1749.1165-.3109.27738-.445.43607l-.0001.00003c-.0301.0357-.0602.0713-.0906.10625-.3409.38061-.789.49481-1.10069.28541-.30194-.19977-.35065-.68504-.08766-1.11321.41883-.69459 1.12985-.95149 1.88965-1.09422.1683-.03738.3427-.04539.4806-.05172.0376-.00173.0725-.00333.1038-.00537zm-1.1689 7.46922c0 .4567.4578.8849.9449.8944.5064.0095.9837-.4282.9837-.9134-.0097-.4662-.448-.8754-.9448-.8849-.5162-.0095-.9838.4282-.9838.9039z" 
        fill="var(--color-text-secondary)" 
        fillRule="evenodd"
      />
    </svg>
  );
};

export default HelpIcon;
